import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { CreditCard } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import EditCreditCard from './EditCreditCard.vue';
    import QueryKey from '@/enums/QueryKey';
    import { usePage } from '@inertiajs/vue3';
    import { computed } from 'vue';
    import type { SharedData } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreditCardTableActions',
  props: {
    creditCard: {}
  },
  setup(__props: any) {

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    

    const { hasPermission } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.creditCard }, {
    default: _withCtx(() => [
      (_unref(hasPermission)(_unref(Permission).CREDIT_CARDS_UPDATE))
        ? (_openBlock(), _createBlock(EditCreditCard, {
            key: 0,
            "credit-card": _ctx.creditCard
          }, null, 8, ["credit-card"]))
        : _createCommentVNode("", true),
      (_unref(hasPermission)(_unref(Permission).CREDIT_CARDS_DELETE))
        ? (_openBlock(), _createBlock(Delete, {
            key: 1,
            route: 
                _ctx.route('v2.credit-cards.destroy', {
                    company: selectedCompanyId.value,
                    creditCard: _ctx.creditCard.id,
                })
            ,
            "query-key": [_unref(QueryKey).CREDIT_CARDS, selectedCompanyId.value],
            header: "credit-cards.delete.title",
            description: "credit-cards.delete.content",
            "success-message": "credit-cards.delete.success"
          }, null, 8, ["route", "query-key"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})